<!-- <template>
  <section :class="['section', 'section--main', 'child-view']">
    <div
      class="visual"
      :style="{ backgroundImage:
      selectedRandomItem.background_type === 'image' ?
      `url('${selectedRandomItem.background_image.path}')` : '' }"
    >
      <video
        class="video"
        v-if="selectedRandomItem.background_type === 'video'"
        autoplay
        loop
        muted
        playsinline
      >
        <source :src="selectedRandomItem.background_video.path || ''" type="video/mp4" />
      </video>
    </div>
    <div class="main" v-html="content"></div>
  </section>
</template> -->

<template>
  <section :class="['section', 'section--main', 'child-view']">
    <div class="visual">
      <video
        class="video"
        autoplay
        loop
        muted
        playsinline
      >
        <source src="/static/videoplayback.mp4" type="video/mp4" />
      </video>
    </div>
    <div class="main" v-html="content"></div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Video from '@/components/Video';

export default {
  components: { Video },
  data() {
    return {
      selectedRandomItem: '',
    };
  },
  computed: {
    ...mapState('pages/main', {
      background: state => state.background,
      content: state => state.content,
      media: state => state.media,
    }),
  },
  created() {
    if (!this.background.type) {
      this.fetchMainPageContent();
    }
    this.fetchMainMediaContent()
      .then(() => {
        const randomMediaItem = Math.floor(Math.random() * this.media.length);
        this.selectedRandomItem = this.media[randomMediaItem];
      });
  },
  methods: {
    ...mapActions({
      fetchMainPageContent: 'pages/main/main:fetch',
      fetchMainMediaContent: 'pages/main/mainMediaContent:fetch',
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Main.vue